/* eslint-disable jsx-a11y/no-distracting-elements */
import styled from "styled-components";
import { Info,Call } from "@material-ui/icons";
import { colors } from "../res/values/values";

const Container = styled.div`
  background-color: #333;
  color: ${colors.blackColor};
  font-size: 16px;
  font-weight: 400;
  padding: 10px 5px; 
  display: flex;
  justify-content: center;
  align-items: center;
`;
function Announcement() {
  return (
    <Container>
     <Info style={{ paddingRight: "20px" }} />{" "}
      Order by Phone 
      <Call style={{ paddingLeft:"8px" }} />{" "}
      +441302 325890
    </Container>
  );
}
/*
<p>We moved to our new address !</p>

<marquee behavior="scroll" direction="left">
      OPEN 24/7 to public - Order by Phone 24/7 020 3937 6970 - 074 9421 4847
      </marquee>
*/
export default Announcement;
